// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"QuestionTooltip_tooltipContainer__1cnBa","bubble":"QuestionTooltip_bubble__qrWWb"};